import { flagFactory } from '../icon';
import Svg from './no.svg';

export default flagFactory(Svg);
